<div class="container h-full overflow-hidden">
    <div class="row my-0 mx-0">
        <div class="col-md-12 mt-3vh">
            <h2>Add Forum Question</h2>
        </div>
        <div class="col-md-12 mb-2vh">
            <mat-form-field class="full-width w-100" appearance="outline">
                <mat-label>Question Title</mat-label>
                <input matInput autocomplete="off" [name]="'question'" [(ngModel)]="question" placeholder="Enter your question title" required>
                <mat-hint>Make your question clear and concise</mat-hint>
            </mat-form-field>
        </div>    
        <div class="col-md-12 mb-3vh">
            <h3 class="mb-2vh">Question Details</h3>
            <ckeditor [editor]="editor" [(ngModel)]="forumQuestion" class="w-100" style="min-height: 30vh;">
            </ckeditor>
            <div class="text-muted mt-2vh">
                <small>Provide all relevant details to help others understand your question</small>
            </div>
        </div>
        
        <div class="col-md-12 text-right mb-3vh">
            <button class="pbmit-btn" (click)="save()">
                <i class="fa fa-save mr-2vw"></i> Save Question
            </button>
        </div>
    </div>
</div>